export const NAME = 'wrappingMachines';